import React from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import AdminConfiguration from 'src/components/pages/adminConfiguration/adminConfiguration';
import AssociateProfile from 'src/components/pages/associateProfile/associateProfile';
import CreateNewJob from 'src/components/pages/createNewJob/createNewJob';
import DefaultSettings from 'src/components/pages/defaultSettings/defaultSettings';
import FeatureFlags from 'src/components/pages/featureFlags/featureFlags';
import GeneralInformation from 'src/components/pages/generalInformation/generalInformation';
import JobConfiguration from 'src/components/pages/jobConfiguration/jobConfiguration';
import RestrictionEntryJmr from 'src/components/pages/newJMR/newJMR';
import PlacementDetails from 'src/components/pages/placementDetails/placementDetails';
import PlacementDetailsRedirect from 'src/components/pages/placementDetails/placementDetailsRedirect';
import PlacementsOverview from 'src/components/pages/placementsOverview/placementsOverview';
import Reporting from 'src/components/pages/reporting/reporting';
import SiteManagement from 'src/components/pages/siteManagement/siteManagement';
import PageNotFound from 'src/components/shared/errorHandle/pageNotFound';
import Unauthorized from 'src/components/shared/errorHandle/unauthorized';
import * as LDAP from 'src/config/LDAP';
import { PLACEMENT_DETAILS_BASEURL, PLACEMENT_OVERVIEW_BASEURL } from 'src/constants/Routes';
import { useAppSelector } from 'src/store/store';

import PlacementDetailsRoute from './placementDetailsRoute';

/**
 * Default component.
 */
const MainContent = () => {
  const { hasPermission, ldap, featureFlags } = useAppSelector((state) => state.user);
  const { hasAllowedSite } = useAppSelector((state) => state.sites);
  const isAdmin = ldap.includes(LDAP.ADMIN);
  const isSMES = ldap.includes(LDAP.SMES);
  const isFCLeaders = ldap.includes(LDAP.FC_LEADERS);
  const isDev = ldap.includes(LDAP.DEV);

  if (!hasPermission || !hasAllowedSite) {
    return <Unauthorized />;
  } else {
    return (
      <Routes>
        <Route path="/" element={<Navigate to="/placementsOverview" />} />
        <Route path="/general" element={<GeneralInformation />} />
        <Route path="/featureFlags" element={<FeatureFlags />} />
        {featureFlags.PERSONA && <Route path="/associateProfile/:alias/*" element={<AssociateProfile />} />}
        <Route path="/placementsOverview" element={<PlacementsOverview />}>
          <Route path=":site/:tab" element={<PlacementsOverview />} />
        </Route>
        {isDev || isAdmin || isSMES || isFCLeaders ? (
          <Route path="/siteManagement/*" element={<SiteManagement />} />
        ) : (
          <Route path="/siteManagement/*" element={<Unauthorized />} />
        )}
        <Route path="/reporting" element={<Reporting />} />
        <Route path="/adminConfiguration" element={<Navigate to="/adminConfiguration/siteConfiguration" />} />
        {isDev || isAdmin ? (
          [
            '/siteConfiguration',
            '/taskConfiguration',
            '/nonPhysicalTaskConfiguration',
            '/taskConfiguration/task',
            '/taskConfiguration/taskGroup',
            '/restrictionFormConfiguration',
            '/restrictionFormConfiguration/forms',
            '/restrictionFormConfiguration/edit/:regionId',
            '/jobModificationConfiguration',
          ].map((path, i) => <Route key={i} path={'/adminConfiguration' + path} element={<AdminConfiguration />} />)
        ) : (
          <Route path="/adminConfiguration/*" element={<Unauthorized />} />
        )}
        {isDev || isAdmin || isSMES ? (
          <Route path="/jobConfiguration" element={<JobConfiguration />} />
        ) : (
          <Route path="/jobConfiguration" element={<Unauthorized />} />
        )}
        <Route path="/defaultSettings" element={<DefaultSettings />} />
        <Route path="/createNewJob" element={<CreateNewJob />} />
        <Route path="/createNewJob/:jobId" element={<CreateNewJob />} />
        <Route path="/newJMR" element={<RestrictionEntryJmr />}>
          <Route path=":alias" element={<RestrictionEntryJmr />} />
          <Route path=":placementId/update/:updateType" element={<RestrictionEntryJmr />} />
          <Route path=":type/:login/:caseId" element={<RestrictionEntryJmr />} />
        </Route>
        <Route
          path={`${PLACEMENT_OVERVIEW_BASEURL}/:placementId`} // deprecated
          element={<PlacementDetailsRoute />}
        />
        <Route path={`${PLACEMENT_DETAILS_BASEURL}/:type/:login/:caseId`} element={<PlacementDetailsRedirect />} />
        <Route path={`${PLACEMENT_DETAILS_BASEURL}/:placementId`} element={<PlacementDetails />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    );
  }
};

// **** Export **** //

export default MainContent;
